module.exports = __webpack_public_path__ + "static/sc-list-7c2a404f732e999329d5409500806665.png";